const localization = {
  regNumber: {
    1: "Регистрационный номер обращения",
    0: "Рэгістрацыйны нумар звароту",
  },
  registerDate: {
    1: "Дата регистрации обращения",
    0: "Дата рэгістрацыі звароту",
  },
  applicant: {
    1: "Заявитель / Организация",
    0: "Заяўнік / Арганізацыя",
  },
  reAppealViewType: {
    1: "Вид обращения",
    0: "Выгляд звароту",
  },
  themeOgul: {
    1: "Тема обращения",
    0: "Тэма звароту",
  },
  subthemeOgul: {
    1: "Подтема обращения",
    0: "Падтэма звароту",
  },
  status: {
    1: "Статус обращения",
    0: "Статус звароту",
  },
  responseSendDate: {
    1: "Дата направления ответа заявителю",
    0: "Дата напрамкі адказу заяўніку",
  },
  address: {
    1: "Адрес заявителя",
    0: "Адрас заяўніка"
  },
  noData: {
    1: "Не найдено потенциально повторных обращений!",
    0: "Не знойдзена патэнцыйна паўторных зваротаў!",
  },
  previousAppealRequired: {
    1: "Необходимо выбрать хотя бы одно повторное обращение.",
    0: "Неабходна выбраць хоць бы адзiн паўторны зварот.",
  },
  IsCorrespondenceTerminated: {
    1: "Прекращена переписка",
    0: "Спыненая перапіска",
  }
};

export default localization;
